import { getAuthHeaders } from "../../../shared/services/authentication";
import { BASE_URL } from "../../../shared/utils/variables";
import { FinancialReportParams } from "../../../pages/reports/financial/financial-report";

const baseURL = BASE_URL;

export const fetchFinancialData = async (id: string) => {
    const url = `${baseURL}/financial/${id}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error fetching financial data:', error);
        throw error;
    }
}

export const fetchFinancialsByProjectIdService = async (id: string) => {
    const url = `${baseURL}/project/${id}/financiers`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();

        return data;
    } catch (error) {
        
    }
}

export const setFinancialData = async (data: any, id: string | null) => {
  try {
    const url = id ? `${baseURL}/financial/${id}` : `${baseURL}/financial`;    
    const method = id ? 'PUT' : 'POST';
    
    if (data.recipt && data.recipt instanceof File) {
      const formData = new FormData();
      
      formData.append('recipt', data.recipt);
      
      Object.keys(data).forEach(key => {
        if (key !== 'recipt') {
          formData.append(key, data[key]);
        }
      });
      
      const response = await fetch(url, {
        method,
        headers: {
          ...getAuthHeaders(),
        },
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } else {

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    }
  } catch (error) {
    console.error('Error in setFinancialData:', error);
    throw error;
  }
};

export const getFinancialsByProjectIdService = async (id: string) => {
    const url = `${baseURL}/financial/${id}/project`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(url, options);
        const data = await response.json();

        return data;
    } catch (error) {
        
    }
}

export const getReciptFinancial = async (id: string) => {
  const url = `${baseURL}/financial/${id}/recipt`;

  const options = {
      method: 'GET',
      headers: { ...getAuthHeaders() },
  };

  try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
          throw new Error(`Erro ao carregar imagem: ${response.status}`);
      }
      
      const blob = await response.blob();
      
      const imageUrl = URL.createObjectURL(blob);
      
      return imageUrl;
  } catch (error) {
      console.error('Erro ao carregar o recibo:', error);
      throw error;
  }
}

export const downloadReciptFinancial = async (id: string, fileName: string) => {
  const url = `${baseURL}/financial/${id}/download-recipt`;

  const options = {
      method: 'GET',
      headers: { ...getAuthHeaders() }
  };

  try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
          throw new Error(`Erro ao baixar imagem: ${response.status}`);
      }
      
      const blob = await response.blob();
      
      let filename = fileName;
      const contentDisposition = response.headers.get('content-disposition');
      if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
          }
      }
      
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setTimeout(() => URL.revokeObjectURL(downloadUrl), 100);
      
      return true;
  } catch (error) {
      console.error('Erro ao baixar o recibo:', error);
      throw error;
  }
}

export const reportFinancialService = async (idProject: string, paramsReport: FinancialReportParams) => {
  const url = `${baseURL}/report-financial/${idProject}`;

  const options = {
      method: 'POST',
      headers: { 
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paramsReport),
  };

  try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
          throw new Error(`Erro ao gerar relatório: ${response.status}`);
      }
      
      return await response.json();
  } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      throw error;
  }
}

export const reportFinancialBothService = async (idProject: string, paramsReport: FinancialReportParams) => {
  const url = `${baseURL}/report-financial-both/${idProject}`;

  const options = {
      method: 'POST',
      headers: { 
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paramsReport),
  };

  try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
          throw new Error(`Erro ao gerar relatório: ${response.status}`);
      }
      
      return await response.json();
  } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      throw error;
  }
}

export const deleteFinancialService = async (id: string) => {
    const url = `${baseURL}/financial/${id}`;
    
    const options = {
        method: 'DELETE',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return response.json();
}

export const checkPaymentMatchService = async (projectId: string, beneficiaryId: string, valor: number) => {
    const url = `${baseURL}/beneficiary-projects/check-payment-match`;
    
    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            projectId,
            beneficiaryId,
            valor
        }),
    };

    try {
        const response = await fetch(url, options);
        
        if (!response.ok) {
            throw new Error(`Erro na verificação de pagamento: ${response.status}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error('Erro ao verificar correspondência de pagamento:', error);
        throw error;
    }
};

export const updatePaymentDateService = async (projectId: string, beneficiaryId: string, valor: number) => {
    const url = `${baseURL}/beneficiary-projects/update-payment-date`;
    
    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            projectId,
            beneficiaryId,
            valor
        }),
    };

    try {
        const response = await fetch(url, options);
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `Erro ao atualizar pagamento: ${response.status}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error('Erro ao atualizar data de pagamento:', error);
        throw error;
    }
};